import { ItemTypeConsts, ItemTypeDisplayNames } from 'client/util/Constants';
import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';
import hashString from 'client/GrowthEngineering/utilities/hashString';

const displayName = ItemTypeDisplayNames[ItemTypeConsts.gSuite];

/**
 * Translates jumpcloud's sort param to google's sort params
 * @see https://developers.google.com/admin-sdk/directory/reference/rest/v1/users/list#query-parameters
 * @see https://docs.jumpcloud.com/1.0/traits/sort
 */
const parseSortParams = (sort) => {
  const sortParts = sort.split('-');
  if (sortParts.length === 1) return { orderBy: sortParts[0], sortOrder: 'ASCENDING' };
  return { orderBy: sortParts[1], sortOrder: 'DESCENDING' };
};

// Helper to add an Id to users being imported without one
const getId = (user) => user.id || hashString(user.email);

class GSuiteImportApi extends CollectionApi {
  constructor(gSuiteId = '') {
    super(`/api/v2/gsuites/${gSuiteId}/import`, {
      limit: 50,
      sort: '',
      searchTerm: '',
    }, 100, true);
  }

  fetch(skip, limit, sort, searchTerm, cancelToken, filters, pageToken) {
    const params = {
      maxResults: limit,
      query: searchTerm,
      pageToken,
    };
    if (sort) {
      const sortParams = parseSortParams(sort);
      Object.assign(params, sortParams);
    }

    return new Promise((resolve, reject) => {
      this.initialize()
        .then(() => axios.get(`${this.baseUrl}?${this.param(params)}`, { cancelToken }))
        .then((resp) => {
          if (resp && typeof resp.data === 'object') {
            const { data } = resp;
            resolve({
              nextPageToken: data.nextPageToken,
              results: data.users,
              totalCount: data.users.length,
            });
          } else {
            reject(new Error(`Unable to retrieve ${displayName} users.`));
          }
        })
        .catch((err) => {
          this.handleFetchError(reject, `Unable to retrieve ${displayName} users.`, err);
        });
    });
  }

  async fetchAll(searchTerm, limit, filters) {
    const params = {
      maxResults: limit ? limit.length : limit,
      query: searchTerm,
    };
    params.filter = this.setFilterTerm(params, filters, searchTerm);

    await this.initialize();
    const users = await this.getAllItems(`${this.baseUrl}?${this.param(params)}`);
    if (users && typeof users === 'object') {
      return (users.map((user) => ({ ...user, id: getId(user) })));
    }
    throw new Error(`Unable to retrieve ${displayName} users.`);
  }

  setGSuiteId(gSuiteId) {
    this.baseUrl = `/api/v2/gsuites/${gSuiteId || ''}/import/jumpcloudusers`;
  }
}

export default new GSuiteImportApi();
